module.exports = __webpack_public_path__ + "img/border5.aee91ecf.png";